// extracted by mini-css-extract-plugin
export default {"menuBlock":"cG-z","title":"dG-z","nav":"eG-z","flexCell":"fG-z","facetLink":"gG-z"};